import "./style.css";
import { getFullDateString, getFullHourAndMinute } from "../../services/formatters";
import { useSession } from "../../hooks/useSession";

export const Riepilogo = ({ showTitle = true }) => {
    const { read } = useSession();

    return (
        <>
            {showTitle && (
                <>
                    <h3 className="text-center">
                        Riepilogo del tuo appuntamento <br />
                    </h3>
                    <br />
                </>
            )}
            <div id="sticky-summary" className="text-center">
                <p>
                    {read("filialeScelta").nomeFiliale || read("filialeScelta").RagioneSociale} <br />
                    {read("filialeScelta").indirizzo || read("filialeScelta").IndirizzoUfficio}
                </p>
                {read("dataScelta") && read("orarioScelto") && (
                    <p>
                        {getFullDateString(read("dataScelta").data)} - Ore {getFullHourAndMinute(read("orarioScelto").hour, read("orarioScelto").minute)}
                    </p>
                )}
            </div>
        </>
    );
};
